require('./insurancePdfViewer.scss');
require('./insurancePdfViewer.override.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const classNames = require('classnames');
//@components
const InsurancePdfViewerError = require('../insurancePdfViewerError/insurancePdfViewerError');
//@Commons components
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');

class InsurancePdfViewer extends React.Component {
    constructor(props) {
        super(props);
    }



    buildViewer() {
        const {
            document,
            errorLoading,
            getDocuments,
            onDownload,
            onPrint,
            scale,
            title,
            viewerHeight,
            checkReadDocument,
        } = this.props;

        const handleOnDocumentRead = () => {
            if (checkReadDocument) {
                checkReadDocument();
            }
        };

        return (
            <div className="insurances-pdf-viewer__document">
                <OKPdfViewer
                    onDownload={onDownload}
                    onPrint={onPrint}
                    pdfFile={document}
                    title={title}
                    scale={scale}
                    errorComponent={() => {
                        return <InsurancePdfViewerError getDocuments={getDocuments} />
                    }}
                    failedLoadingPdf={errorLoading}
                    viewerHeight={viewerHeight}
                    infiniteScroll={false}
                    onDocumentReaded={handleOnDocumentRead}
                />
            </div>
        );
    }

    buildCheckbox() {
        const {
            agreeCheckbox,
            checkboxLabel,
            onAgreeCheckbox,
            errorLoading,
            hasSignaturePattern,
            immSignaturePattern,
            isFetchingForPreview,
            isLoading,
        } = this.props;
        const signaturePatternLoading = (
            immSignaturePattern.get('isFetchingConfig') ||
            immSignaturePattern.get('isFetchingSMSCode') ||
            immSignaturePattern.get('isFetchingSignaturePassCode') ||
            immSignaturePattern.get('callbackCalled')
        );

        const loading = (hasSignaturePattern && signaturePatternLoading);
        const checkbox = isFetchingForPreview ? <LoadingSection /> : (
            <OKCheckbox
                disabled={loading || isLoading}
                idName="acceptConditionsCheck"
                label={checkboxLabel}
                onChange={onAgreeCheckbox}
                value={agreeCheckbox}
            />
        );

        return !errorLoading ? checkbox : null;
    }

    buildLoadingDownload() {
        const { loadingDownload } = this.props;

        return loadingDownload ? (
            <LoadingSection />
        ) : null;
    }

    render() {
        const { isLoading, documentRead } = this.props;
        const viewer = isLoading ? <LoadingSection /> : this.buildViewer();
        const checkbox = this.buildCheckbox();
        const loadingDownloadSpinner = this.buildLoadingDownload();
        const classNameContainer = classNames('insurances-pdf-viewer');

        return (
            <div className={classNameContainer}>
                {viewer}
                {documentRead && checkbox}
                {loadingDownloadSpinner}
            </div>
        );
    }
}

InsurancePdfViewer.propTypes = {
    agreeCheckbox: PropTypes.bool,
    checkboxLabel: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    document: PropTypes.string.isRequired,
    errorLoading: PropTypes.bool.isRequired,
    getDocuments: PropTypes.func.isRequired,
    hasSignaturePattern: PropTypes.bool,
    immSignaturePattern: PropTypes.object.isRequired,
    isFetchingForPreview: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    loadingDownload: PropTypes.bool,
    onAgreeCheckbox: PropTypes.func,
    onDownload: PropTypes.func,
    onPrint: PropTypes.func,
    scale: PropTypes.number,
    title: PropTypes.string,
    viewerHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    checkReadDocument: PropTypes.func,
    documentRead: PropTypes.bool,
};

InsurancePdfViewer.defaultProps = {
    scale: 1.2
};

module.exports.constructor = InsurancePdfViewer;

module.exports.InsurancePdfViewer = connect(state => ({
    immSignaturePattern: state.signaturePattern
}))(InsurancePdfViewer);
